'use strict';

import { view } from '@/functions';

const prefix = '/affiliation-requests';
const scopes = ['read_accounts', 'read_affiliations', 'write_affiliations'];

export default [
    {
        path: prefix,
        name: 'affiliation-requests',
        meta: {
            title: 'Affiliation Requests',
            scopes,
        },
        component: () => view('affiliation-requests/index'),
    },
    {
        path: `${prefix}/info`,
        name: 'affiliation-requests-info',
        meta: {
            title: 'Affiliation Request',
            scopes,
        },
        component: () => view('affiliation-requests/info'),
    },
];
